import { client } from "Service/axios";
import {
  VEHICLE_TYPES,
  VEHICLE_TYPES_CREATE,
} from "Shared/Constants/apiRequest";
import { DefaultRequestParams, IAddType } from "Shared/Types/type";

class Type {
  getTypeList(params: DefaultRequestParams | null, signal?: AbortSignal) {
    return client.get<any>(VEHICLE_TYPES, { params, signal });
  }
  addType(data: IAddType) {
    return client.post<any>(VEHICLE_TYPES_CREATE, data);
  }
}

export default Type;
